// AI Generated Service
import { Injectable } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';

@Injectable({
    providedIn: 'root',
})
export class SeoHelpMessageService {
    constructor (private readonly translateService: TranslateService) {}

    getHelpMessage (checkpoint: { name: string }): string {
        let message = '';
        switch (checkpoint.name) {
            case 'seo_missing_h1':
                message = this.translateService.getString('There is no H1 on one or more pages');
                break;
            case 'seo_missing_meta_description':
                message = this.translateService.getString('There are no META descriptions on one or more pages');
                break;
            case 'seo_missing_subheadlines':
                message = this.translateService.getString('There are no sub headlines on one or more pages');
                break;
            case 'seo_missing_title':
                message = this.translateService.getString('No title found on one or more pages');
                break;
            case 'seo_no_index':
                message = this.translateService.getString('One or more pages has been marked as no index');
                break;
        }
        return message;
    }

    canShowMessageForDomain (checkpoint: { name: string }): boolean {
        switch (checkpoint.name) {
            case 'seo_missing_h1':
            case 'seo_missing_title':
            case 'seo_missing_subheadlines':
            case 'seo_missing_meta_description':
            case 'seo_no_index':
                return true;
            case 'seo_too_short_meta_description':
            case 'seo_too_many_page_links':
            case 'seo_too_long_url':
            case 'seo_too_long_meta_description':
            case 'seo_no_follow':
            case 'seo_multiple_h1':
            case 'seo_duplicate_h1':
            case 'seo_duplicate_title':
            case 'seo_missing_alt':
                return false;
            default:
                return false;
        }
    }
}
